import React, { ChangeEventHandler, FC, useEffect, useState } from 'react'
import { SearchIcon } from 'uiKit/icons/Icons'
import { CrossIcon } from 'uiKit/icons/CrossIcon'
import * as Styles from './styles'
import { SearchFieldProps } from './type'

export const TrainSearchInput: FC<SearchFieldProps> = ({
  value: defaultValue = '',
  placeholder,
  updateSearchValue,
}) => {
  const [value, setValue] = useState(defaultValue)

  const onSearchChanged: ChangeEventHandler<HTMLInputElement> = event => {
    setValue(event.target.value)
  }

  useEffect(() => {
    updateSearchValue(value)
  }, [value])

  return (
    <Styles.SearchContainer>
      <Styles.SearchWrapper>
        <Styles.Input placeholder={placeholder} value={value} onChange={onSearchChanged} />
        {!value && <SearchIcon width="20" height="20" color="#D8D8D8" />}
        {value && <Styles.IconWrap onClick={() => setValue('')} ><CrossIcon size="18" color="inherit" /></Styles.IconWrap>}
      </Styles.SearchWrapper>
    </Styles.SearchContainer>
  )
}
